// @TODO <HEALTH2019>
App.filter('healthInsuranceVariantFilter', function () {
    var dictionary = {
        PARTNER: 'Partnerski',
        SINGLE: 'Indywidualny',
        FAMILY: 'Rodzinny',
    };

    return function (el) {
        if(!el){
            return el;
        }

        return dictionary[el] || el;
    };
});
// @TODO </HEALTH2019>
